// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"528":"codemirror","909":"notifications","961":"returns"}[chunkId] || chunkId) + "." + {"118":"46c43a9f4c90e36ba929","528":"93a31db94597f2dde60d","769":"5402b00e27f632ce87b5","909":"9b506999c314562590d5","961":"ede8f928b172a1f94f23"}[chunkId] + ".js";
};